console.log("updatesw loaded");

export function updateSW() {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (let registration of registrations) {
      registration.unregister();
    }
    window.location.reload(true);
  });
}
